// Runtime and financial snapshots require their own fresh response.
export function withoutUnconfirmedRuntime(bot) {
    const result = { ...bot };
    for (const field of ['position_snapshot', 'runtime_state', 'dca_runtime', 'pnl', 'total_pnl',
        'current_capital', 'trade_metrics', 'statistics', 'lastSignal', 'history_snapshot', 'diagnostics_snapshot',
        'simulation_snapshot_ready', 'state']) delete result[field];
    if (result.safety && typeof result.safety === 'object') {
        const { safetyState, exposureBlocked, protectionStatus, blockedReason } = result.safety;
        result.safety = { safetyState, exposureBlocked, protectionStatus, blockedReason };
    }
    result.__freshPresentationRequired = true;
    return result;
}
